import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_page_card = _resolveComponent("page-card")!
  const _component_monaco_editor = _resolveComponent("monaco-editor")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_app_page = _resolveComponent("app-page")!

  return (_openBlock(), _createBlock(_component_app_page, null, {
    main: _withCtx(() => [
      _createVNode(_component_page_card, { title: "" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_descriptions, {
            title: "日志详情",
            column: 3,
            border: "",
            class: "content"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.logDetailKeyMap, (item, key) => {
                return (_openBlock(), _createBlock(_component_el_descriptions_item, {
                  key: key,
                  label: `${item.label}：`,
                  "label-align": "center"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.formatter ? item.formatter(_ctx.logDetail[key]) : _ctx.logDetail[key]), 1)
                  ]),
                  _: 2
                }, 1032, ["label"]))
              }), 128)),
              _createVNode(_component_el_descriptions_item, {
                label: "日志内容：",
                "label-align": "center"
              }, {
                default: _withCtx(() => [
                  (_ctx.logDetail.logContent)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 0,
                        type: "primary",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleShowDetail('logContent', '日志内容')))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 查看 ")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_dialog, {
        modelValue: _ctx.detailDialogInfo.visible,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.detailDialogInfo.visible) = $event)),
        title: _ctx.detailDialogInfo.title
      }, {
        default: _withCtx(() => [
          _createVNode(_component_monaco_editor, {
            value: _ctx.detailDialogInfo.value
          }, null, 8, ["value"])
        ]),
        _: 1
      }, 8, ["modelValue", "title"])
    ]),
    _: 1
  }))
}